import React from "react";
import "../../styles/components/loader.scss";

function Loader() {
  return (
    <div className="loader__container">
      <div className="loader"></div>
    </div>
  );
}

export default Loader;
